import React from 'react';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Good360.json';
import inputTypeIntro from '../static/introspection/Good360CreateInput.json';
import { ENTITY } from '../utils/entities';
import { Good360CreateMutation } from 'graphql/mutations/Good360CreateMutation';
import { Good360DetailQuery } from 'graphql/query/Good360DetailQuery';
import { graphqlQuery } from 'utils/graphql';
import { ACTIONS, generateUrl } from 'utils/urls';
import { GOOD_360_CREATE_DEFAULTS } from 'utils/entities/good360';

const Good360Create = ({ id }) => (
	<EntityEditFetcher
		fetcher={id ? graphqlQuery(Good360DetailQuery, { id }) : null}
		create={true}
		clone={!!id}
		id={id}
		mutation={Good360CreateMutation}
		typeIntro={typeIntro}
		inputTypeIntro={inputTypeIntro}
		entityName={ENTITY.GOOD_360}
		customDetailUrl={(newId) =>
			generateUrl(ENTITY.GOOD_360, ACTIONS.DETAIL, newId) + '?flow=postcreate'
		}
		fields={['Good']}
		beforeSaveTransformer={(values: any) => ({
			...GOOD_360_CREATE_DEFAULTS,
			...values,
		})}
	/>
);

export { Good360Create };